import benchImage from "../assets/images/benchdesigns.jpg";
import { useEffect } from "react";
import HeaderBottomOne from "../common/header/HeaderBottomOne";
import FooterOne from "../common/footer/FooterOne";

const Benchmark = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <>
      <HeaderBottomOne />
      <div className="benchmark-page">
        <img
          src={benchImage}
          alt="Benchmark Designs"
          style={{ width: "100%", height: "auto", marginBottom: "20px" }}
        />
      </div>
      <FooterOne />
    </>
  );
};

export default Benchmark;
